import React from 'react';
export const Footer = () => {
  return <>
      <footer className="bg-dark-900 border-t border-white/5 py-12 px-4" data-id="element-57">
        <div className="max-w-6xl mx-auto text-center" data-id="element-58">
          <h2 className="font-oswald text-2xl font-bold text-white uppercase tracking-widest mb-6" data-id="element-59">
            Hombre Apagado <span className="text-gold-500" data-id="element-60">No Más</span>
          </h2>
          <p className="text-zinc-500 text-sm mb-8 max-w-2xl mx-auto" data-id="element-61">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-4 text-sm" data-id="element-62">
            <a href="#privacy-policy" className="text-zinc-400 hover:text-white transition-colors" data-id="element-63">
              Política de Privacidad
            </a>
            <a href="#terms-and-conditions" className="text-zinc-400 hover:text-white transition-colors" data-id="element-64">
              Términos y Condiciones
            </a>
          </div>
          <div className="text-zinc-600 text-sm mt-6" data-id="element-65">
            &copy; {new Date().getFullYear()} Hombre Apagado No Más. Todos los
            derechos reservados.
          </div>
        </div>
      </footer>

      <section id="privacy-policy" className="bg-dark-900 text-zinc-300 px-6 py-12" data-id="element-66">
        <div className="max-w-4xl mx-auto" data-id="element-67">
          <h2 className="text-2xl font-bold mb-4" data-id="element-68">Política de Privacidad</h2>
          <p className="mb-4" data-id="element-69">
            Respetamos tu privacidad y protegemos tu información personal. Los
            datos que compartas en este sitio serán utilizados únicamente para
            brindarte información, soporte y acceso a nuestros servicios.
          </p>
          <p className="mb-4" data-id="element-70">
            No vendemos ni compartimos tu información personal con terceros no
            autorizados. Podemos usar ciertos datos para mejorar la experiencia
            del usuario y ofrecer contenido relevante.
          </p>
          <p data-id="element-71">Al usar este sitio, aceptas esta política de privacidad.</p>
        </div>
      </section>

      <section id="terms-and-conditions" className="bg-dark-900 text-zinc-300 px-6 py-12 border-t border-zinc-800" data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <h2 className="text-2xl font-bold mb-4" data-id="element-74">Términos y Condiciones</h2>
          <p className="mb-4" data-id="element-75">
            Este sitio tiene fines informativos y educativos. El uso de este
            sitio implica la aceptación de estos términos y condiciones.
          </p>
          <p className="mb-4" data-id="element-76">
            No garantizamos resultados específicos. Cada usuario es responsable
            del uso que haga de la información presentada en este sitio.
          </p>
          <p data-id="element-77">
            Nos reservamos el derecho de actualizar o modificar estos términos
            en cualquier momento.
          </p>
        </div>
      </section>
    </>;
};